module.exports = __webpack_public_path__ + "static/img/oilserve1.f2330e67.png";